(() => {
  const closeItem = (item) => {
    if (!item) return;
    const toggle = item.querySelector(".faq__toggle");
    const answer = item.querySelector(".faq__answer");
    if (!toggle || !answer || !toggle.classList.contains("active")) return;

    toggle.setAttribute("aria-expanded", "false");
    item.classList.remove("is-active");
    slideUp(toggle, answer, 300);
  };

  const openItem = (item) => {
    if (!item) return;
    const toggle = item.querySelector(".faq__toggle");
    const answer = item.querySelector(".faq__answer");
    if (!toggle || !answer || toggle.classList.contains("active")) return;

    toggle.setAttribute("aria-expanded", "true");
    item.classList.add("is-active");
    slideDown(toggle, answer, 300);
  };

  const initSection = (section) => {
    if (!section || !section.classList.contains("faq-section")) return;

    const list = section.querySelector(".faq__list");
    if (!list) return;

    const items = Array.from(list.querySelectorAll(".faq__item"));
    const allowMultiple = list.dataset.allowMultiple === "true";

    const activeItems = items.filter((item) => {
      const toggle = item.querySelector(".faq__toggle");
      return toggle && toggle.classList.contains("active");
    });

    if (!allowMultiple && activeItems.length > 1) {
      activeItems.slice(1).forEach((item) => closeItem(item));
    }

    items.forEach((item) => {
      const toggle = item.querySelector(".faq__toggle");
      const answer = item.querySelector(".faq__answer");
      if (!toggle || !answer) return;

      if (toggle.classList.contains("active")) {
        toggle.setAttribute("aria-expanded", "true");
        item.classList.add("is-active");
      } else {
        toggle.setAttribute("aria-expanded", "false");
        item.classList.remove("is-active");
      }

      toggle.addEventListener("click", () => {
        const isActive = toggle.classList.contains("active");

        if (isActive) {
          closeItem(item);
          return;
        }

        if (!allowMultiple) {
          items.forEach((otherItem) => {
            if (otherItem !== item) closeItem(otherItem);
          });
        }

        openItem(item);
      });
    });
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initSection(event.target);
  });
})();
